import React from 'react';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider, Typography } from '@material-ui/core/';
import * as ROUTES from './utils/routes';
import theme from './utils/theme';
import { makeStyles } from '@material-ui/core/styles';
// Components
import NavbarContainer from './containers/NavbarContainer';
import AuthRoute from './utils/AuthRoute';
// Pages
import loginPage from './pages/loginPage';
import signupPage from './pages/signupPage';
import devicesPage from './pages/devicesPage';
import externalAppsPage from './pages/externalAppsPage';
import managedAppsPage from './pages/managedAppsPage';
import appbundlesPage from './pages/appbundlesPage';
import usersPage from './pages/usersPage';
import dashboardPage from './pages/dashboardPage';
import analyticsDashboardPage from './pages/analyticsDashboardPage';
import organizationsPage from './pages/organizationsPage';
import { termsPage } from './pages/termsPage';
import { ApiKeysPage } from './pages/apiKeysPage';

import brandingPage from './pages/brandingPage';
import { Provider } from 'react-redux';
import store from './redux/store';

// <AuthRoute
//   exact
//   path={ROUTES.ANALYTICS}
//   component={analyticsDashboardPage}
// />

const useStyles = makeStyles((t) => ({
    root: {
        display: 'flex',
        backgroundColor: '#f5f5f5',
    },
    navBar: {
        width: theme.sizes.navBarWidth,
        height: '100%',
        flexShrink: 0,
    },
    content: {
        flexGrow: 1,
        width: `calc(100% - ${theme.sizes.navBarWidth}px)`,
        padding: `0px ${theme.spacing(2)}`,
    },
    banner: {
        // background: theme.palette.success.main,
        background: '#291955',
        padding: theme.spacing(1),
        // paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: 'white',

        display: 'flex',
        alignItems: 'center',
        borderRadius: 4,
        '& a': {
            color: '#cfc4ee',
        },
    },
}));

function App() {
    const classes = useStyles();
    return (
        <MuiThemeProvider theme={theme}>
            <div className={classes.root}>
                <Provider store={store}>
                    <BrowserRouter>
                        <div className={classes.navBar}>
                            <NavbarContainer />
                        </div>
                        <main className={classes.content}>
                            <div className={classes.banner}>
                                <div style={{ padding: 4 }}>
                                    <img src="/managexr.png" alt="ManageXR logo" style={{ height: '50px' }} />
                                </div>
                                <div style={{ marginLeft: 16 }}>
                                    <Typography variant="body1">
                                        <b>Important Announcement:</b> Mighty MDM is exiting beta and launching as{' '}
                                        <a href="https://www.managexr.com" target="_blank">
                                            ManageXR
                                        </a>
                                        ! A new and improved web console is ready for you to use at{' '}
                                        <a href="https://console.managexr.com" target="_blank">
                                            console.managexr.com
                                        </a>
                                        . Please login to the new console using your Mighty MDM credentials and watch our{' '}
                                        <a href="https://youtu.be/-8v_l4GXsQI" target="_blank">
                                            announcement video
                                        </a>{' '}
                                        to learn more.
                                    </Typography>
                                    <Typography variant="caption">
                                        <br />
                                        <i>Note: This Mighty MDM management portal will be phased out on March 5th.</i>
                                    </Typography>
                                </div>
                            </div>
                            <Switch>
                                <Route exact path={ROUTES.LOGIN} component={loginPage} />
                                <Route exact path={ROUTES.SIGNUP} component={signupPage} />
                                <Route exact path={ROUTES.TERMS} component={termsPage} />

                                <AuthRoute exact path={ROUTES.BRANDING} component={brandingPage} />
                                <AuthRoute exact path={ROUTES.DASHBOARD} component={dashboardPage} />

                                <AuthRoute exact path={ROUTES.ORGANIZATIONS} component={organizationsPage} />
                                <AuthRoute exact path={ROUTES.ORGANIZATIONS_INFO} component={organizationsPage} />

                                <AuthRoute exact path={ROUTES.DEVICES} component={devicesPage} />
                                <AuthRoute exact path={ROUTES.DEVICES_INFO} component={devicesPage} />
                                <AuthRoute exact path={ROUTES.DEVICE_GROUPS_INFO} component={devicesPage} />

                                <AuthRoute exact path={ROUTES.MANAGED_APPS} component={managedAppsPage} />
                                <AuthRoute exact path={ROUTES.MANAGED_APPS_INFO} component={managedAppsPage} />

                                <AuthRoute exact path={ROUTES.EXTERNAL_APPS} component={externalAppsPage} />
                                <AuthRoute exact path={ROUTES.EXTERNAL_APPS_INFO} component={externalAppsPage} />

                                <AuthRoute exact path={ROUTES.API_KEYS} component={ApiKeysPage} />

                                <AuthRoute exact path={ROUTES.USERS} component={usersPage} />
                                <AuthRoute exact path={ROUTES.USERS_INFO} component={usersPage} />
                            </Switch>
                        </main>
                    </BrowserRouter>
                </Provider>
            </div>
        </MuiThemeProvider>
    );
}

export default App;
